module.exports = __webpack_public_path__ + "img/undraw_video_call_kxyp.25d79937.svg";